import { IconProps } from '../icon-props-interface';
import '../icons.scss';

export const IconFunnel = ({ color = 'var(--color-accent-1)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 1.65918C0 0.985351 0.547852 0.4375 1.22168 0.4375H13.7783C14.4521 0.4375 15 0.985351 15 1.65918C15 1.94043 14.9033 2.21289 14.7246 2.42969L9.84375 8.4209V12.6162C9.84375 13.1377 9.41895 13.5625 8.89746 13.5625C8.68359 13.5625 8.47559 13.4893 8.30859 13.3574L5.59863 11.207C5.31738 10.9844 5.15625 10.6475 5.15625 10.29V8.4209L0.275391 2.42969C0.0966797 2.21289 0 1.94043 0 1.65918ZM1.61133 1.84375L6.4043 7.72656C6.50684 7.85254 6.5625 8.00781 6.5625 8.17188V10.1758L8.4375 11.6641V8.17188C8.4375 8.01074 8.49316 7.85254 8.5957 7.72656L13.3887 1.84375H1.61133Z"
                fill={color}
            />
        </svg>

    </div>
);

export default IconFunnel;
